import { toast } from 'react-toastify';
import NavbarV2 from '../../components/navbarV2/NavbarV2';
import './ContactV2.css';

const ContactV2 = () => {
    const sendContactEmail = (e) => {
        e.preventDefault();

        const firstName = document.getElementById("firstName").value;
        const lastName = document.getElementById("lastName").value;
        const email = document.getElementById("email").value;
        const message = document.getElementById("message").value;

        if (firstName === "") {
            toast.error('First name is required.');
            return;
        }
        if (lastName === "") {
            toast.error('Last name is required.');
            return;
        }
        if (email === "") {
            toast.error('Email is required.');
            return;
        }
        if (message === "") {
            toast.error('Message is required.');
            return;
        }

        fetch(`${process.env.REACT_APP_API}/api/sendContactEmail`, {
            method: 'POST',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({
                name: firstName + ' ' + lastName,
                email: email,
                message: message
            })
        })
        .then(response => {
            if (response.status === 200) {
                document.getElementById("firstName").value = "";
                document.getElementById("lastName").value = "";
                document.getElementById("email").value = "";
                document.getElementById("message").value = "";

                toast.success('Sent email!')
            } else if (response.status === 500) {
                toast.error('Server error.')
            }
        });
    }

    return (
        <div className="v2-page contactv2">
            <NavbarV2 />

            <div className="v2-container v2-container--narrow">
                <h1 className="v2-h1">Contact</h1>
                <p className="v2-muted contactv2-lead">
                    Questions about an order, delivery, or products? Send us a message and we will reply by email.
                </p>

                <div className="v2-card">
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            sendContactEmail(e);
                        }}
                    >
                        <h2 className="v2-card-title">Message</h2>
                        <div className="v2-field-row">
                            <div className="v2-field">
                                <label htmlFor="firstName">First name</label>
                                <input type="text" name="firstName" id="firstName" />
                            </div>
                            <div className="v2-field">
                                <label htmlFor="lastName">Last name</label>
                                <input type="text" name="lastName" id="lastName" />
                            </div>
                        </div>

                        <div className="v2-field">
                            <label htmlFor="email">Email</label>
                            <input type="email" name="email" id="email" />
                        </div>

                        <div className="v2-field">
                            <label htmlFor="message">Message</label>
                            <textarea name="message" id="message" />
                        </div>

                        <div className="v2-actions">
                            <button type="submit" className="v2-btn v2-btn--primary">
                                Send message
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ContactV2;